import {ApiModel} from "../../classes/api/class.api.model";

export class ApiCartItem extends ApiModel {
    cart_id;

    constructor(properties = {})
    {
        let fillable = [
            'idx',
            'cart_id',
            'group_uid',
            'product',
            'quantity',
            'event_id',
        ];

        super(fillable, properties);

        this.cart_id = properties['cart_id'];
    }

    static create(cart_id, cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            ApiModel.callAPI(route('api.cart.item.store', { cart_id: cart_id }), cart_item_data, 'POST')
                .then(cart_item => {
                    resolve(cart_item);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                })
        });
    }

    static createWithQty(cart_id, cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            ApiModel.callAPI(route('api.cart.items.store.qty', { cart_id: cart_id }), cart_item_data, 'POST')
                .then(cart_item => {
                    resolve(cart_item);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    static find(item_id)
    {

    }

    update(new_cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            let endpoint = route(
                'api.cart.item.update',
                {
                    cart_id: this.cart_id,
                    cart_item_id: this.idx,
                }
            );

            ApiModel.callAPI(endpoint, new_cart_item_data, 'PUT')
                .then(cart_item_data => {
                    console.log(cart_item_data);
                    resolve(cart_item_data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                })
        });
    }
}
